export default __webpack_public_path__ + "static/media/generalLabour.eca63da3.svg";